import { connect } from 'react-redux';

import {
  fetchHiddenPageSuggestions,
  toggleHiddenPageSuggestion,
  fetchPages,
  bulkUpdateCmsPageVisibility,
} from 'actions/website/PageActions';
import { toggleWebsite } from 'actions/WeddingActions';
import { showModal, hideModal } from 'actions/ModalActions';
import { fetchRegistry, updateRegistryPublish } from 'actions/RegistryActions';

import HidePagesModal from './HidePagesModal';

const mapStateToProps = state => ({
  pages: state.website.pages,
  registry: state.registry,
  registryIds: state.user.userContext.registry_ids,
  weddingThemeKey: state.wedding.theme.key,
  weddingDate: state.wedding.wedding.wedding_date,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getHiddenPageSuggestions: () => dispatch(fetchHiddenPageSuggestions()),
  getPages: () => dispatch(fetchPages()),
  getRegistry: () => dispatch(fetchRegistry()),
  onPublishRegistry: isPublic => dispatch(updateRegistryPublish(isPublic)),
  onPublishWebsite: () =>
    dispatch(toggleWebsite(true)).then(() => {
      if (ownProps.afterPublish) {
        return ownProps.afterPublish();
      }
      return dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'v2' }));
    }),
  showWeddingDateModal: () => dispatch(showModal('WEDDING_DATE', {}, { size: 'v2' })),
  onTogglePage: (id, hidden) =>
    dispatch(toggleHiddenPageSuggestion(id, !hidden)).then(() =>
      dispatch(fetchHiddenPageSuggestions())
    ),
  onBulkUpdatePageVisibility: updateCmsPageHiddenRequest =>
    dispatch(bulkUpdateCmsPageVisibility(updateCmsPageHiddenRequest)),
  closeModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HidePagesModal);



// WEBPACK FOOTER //
// ./src/components/manage/common/HidePagesModal/index.js